import { useEffect, useRef, useState } from "react";

const locale = "en";

const formatDate = (date) => {
  const day = date.toLocaleDateString(locale, { weekday: "long" });
  const month = date.toLocaleDateString(locale, { month: "long" });
  return `${day}, ${date.getDate()} ${month}`;
};

const formatTime = (date) =>
  date.toLocaleTimeString(locale, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

export const useDate = () => {
  const now = new Date();

  const [time, setTime] = useState(() => formatTime(now));
  const [date, setDate] = useState(() => formatDate(now));

  const lastMinuteRef = useRef(now.getMinutes());
  const rafRef = useRef(null);

  useEffect(() => {
    const loop = () => {
      const current = new Date();
      const currentMinute = current.getMinutes();

      if (currentMinute !== lastMinuteRef.current) {
        lastMinuteRef.current = currentMinute;

        setTime(formatTime(current));

        setDate((prev) => {
          const next = formatDate(current);
          return prev === next ? prev : next;
        });
      }

      rafRef.current = requestAnimationFrame(loop);
    };

    rafRef.current = requestAnimationFrame(loop);

    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return { time, date };
};
